import { render } from "./ViewVente.vue?vue&type=template&id=7e0975c1&scoped=true&ts=true"
import script from "./ViewVente.vue?vue&type=script&lang=ts"
export * from "./ViewVente.vue?vue&type=script&lang=ts"

import "./ViewVente.vue?vue&type=style&index=0&id=7e0975c1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e0975c1"]])

export default __exports__